import React from 'react'
import CountUp from 'react-countup';
import { useSelector } from 'react-redux';
import { Card, CardBody } from 'reactstrap';
//Import Icons
import FeatherIcon from "feather-icons-react";

const VisualizacoesRecentes = () => {
  const visualizacoes = useSelector((state) => {
    const { visualizacoesPorPagina } = state.DashboardAnalytics.realTime.data;
    const totals = visualizacoesPorPagina?.totals?.[0]?.metricValues?.[0]?.value;
    if (totals) {
      return +totals;
    }
    return 0;
  });

  return (
    <Card>
      <CardBody>
        <p className="d-inline-block fw-medium text-muted text-uppercase mb-0">Visualizações</p>
        <div className="d-flex justify-content-between">
          <h1 className="mt-4 ff-secondary fw-semibold">
            <span className="counter-value ms-2">
              <CountUp
                start={0}
                end={visualizacoes}
                duration={4}
                separator={'.'}
              />
            </span>
          </h1>
          <div className="avatar-sm flex-shrink-0 align-self-end">
            <span className="avatar-title bg-warning rounded-circle fs-2">
              <FeatherIcon
                icon="eye"
              />
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default VisualizacoesRecentes;